import script from "./JobAndTaskTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./JobAndTaskTemplate.vue?vue&type=script&setup=true&lang=ts"

import "./JobAndTaskTemplate.vue?vue&type=style&index=0&id=12e8ae68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12e8ae68"]])

export default __exports__